import { useState, useEffect } from "react";
import {
  FileDown,
  Plus,
  RefreshCcw,
  Eye,
  Store,
  Clock,
  IndianRupee,
  UserRound,
  WalletCards,
  Save,
} from "lucide-react";
import { exportAnyJsonToExcel } from "../../Utils/exportAnyJsonToExcel";
import { Toaster } from "sonner";
import { useGlobalContext } from "../../../GlobalContext";
import LoadingScreen from "../../Utils/LoadingScreen";
import * as Dialog from "@radix-ui/react-dialog";
import TablePagination from "../../Utils/TablePagination";
import { Info } from "lucide-react";
import AddVolunteerModal from "./AddVolunteerModal";
import EditVolunteerModal from "./EditVolunteerModal";
import AssignVolunteerModal from "./AssignVolunteerModal";
import EditVolunteerKycModal from "./EditVolunteerKycModal";
import ViewVolunteerKycDetails from "./ViewVolunteerKycDetails";
import VolunteerDetailsModal from "./VolunteerDetailsModal";
import AssignVolunteerShopModal from "./AssignVolunteerShopModal";
import VolunteerDutyModal from "./VolunteerDutyType";
import useVolunteers from "../../../Hooks/Volunteer Api/useVolunteers";
import useVolunteerKyc from "../../../Hooks/Volunteer Api/useVolunteerKyc";
import useVolunteerCharges from "../../../Hooks/Volunteer Api/useVolunteerCharges";
import useKYCImageUpload from "../../../Sevices/Driver Api/useKYCImageUpload";

export default function VolunteerPage() {
  const { AdminId } = useGlobalContext();

  const { uploadImageToServer } = useKYCImageUpload();

  const {
    volunteerCharges,
    volunteerChargesLoading,
    addVolunteerChargesApi,
    fetchVolunteerCharges,
  } = useVolunteerCharges();

  const {
    volunteer,
    loading,
    fetchAllVolunteers,
    updateVolunteerDutyTimeApi,
    updateVolunteerDutyTypeApi,
  } = useVolunteers();

  const {
    volunteerKyc,
    volunteerKycList,
    fetchVolunteerKycDetails,
    submitVolunteerKycStep,
    handleVolunteerKycAction,
    fetchAllVolunteerKycDetails,
    loading: kycLoading,
  } = useVolunteerKyc();

  const [Loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("list");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const [editKycModalOpen, setEditKycModalOpen] = useState(false);
  const [selectedVolunteer, setSelectedVolunteer] = useState(null);
  const [detailsVolunteer, setDetailsVolunteer] = useState(null);
  const [editKycVolunteer, setEditKycVolunteer] = useState(null);
  const [openKycDialogId, setOpenKycDialogId] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [volunteerKycStatus, setVolunteerKycStatus] = useState(null);

  const [currentStep, setCurrentStep] = useState(1);
  const [kycFormdata, setKycFormData] = useState({
    volunteer_code: "",
    email: "",
    phone: "",
    aadhaar_no: "",
    pan_no: "",
    city: "",
    area: "",
    profilePicture: null,
    aadhaar_front: null,
    aadhaar_back: null,
    pan_front: null,
  });

  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [teamSelectOpen, setTeamSelectOpen] = useState(false);
  const [selectedTeamIds, setSelectedTeamIds] = useState([]);
  const [teamDriverId, setTeamDriverId] = useState(null);
  const [assignTeamsOpen, setAssignTeamsOpen] = useState(false);
  const [primaryTeamOpen, setPrimaryTeamOpen] = useState(false);
  const [volunteerExistingTeams, setDriverExistingTeams] = useState([]);
  const [selectedVolunteerForTeams, setSelectedVolunteerForTeams] =
    useState(null);
  const [assignTeamDriverObj, setAssignTeamDriverObj] = useState(null);
  const [assignShopOpen, setAssignShopOpen] = useState(false);
  const [selectedVolunteerForShop, setSelectedVolunteerForShop] =
    useState(null);
  const [dutyModalOpen, setDutyModalOpen] = useState(false);
  const [selectedVolunteerForDuty, setSelectedVolunteerForDuty] =
    useState(null);
  const [togglingId, setTogglingId] = useState(null);
  const [chargeForm, setChargeForm] = useState({
    volunteerId: "",
    perDayAmount: "",
  });

  const [addingCharge, setAddingCharge] = useState(false);

  const volunteersPerPage = 25;

  const toggleVolunteerDutyStatus = async (volunteer) => {
    const currentStatus = String(volunteer.duty_status || "")
      .toLowerCase()
      .replace("_", " ")
      .trim();

    const newStatus = currentStatus === "on duty" ? "off_duty" : "on_duty";

    setTogglingId(volunteer.volunteer_code);

    const success = await updateVolunteerDutyTimeApi(
      volunteer.volunteer_code,
      newStatus,
    );

    if (success) {
      await fetchAllVolunteers(AdminId || "");
    }

    setTogglingId(null);
  };

  const filteredVolunteers = (volunteer || []).filter((v) => {
    const fullName = `${v.firstName || ""} ${v.lastName || ""}`.toLowerCase();

    const matchSearch =
      fullName.includes(search.toLowerCase()) ||
      v.username?.toLowerCase().includes(search.toLowerCase());

    const matchStatus = selectedStatus
      ? v.duty_status === selectedStatus
      : true;

    return matchSearch && matchStatus;
  });

  useEffect(() => {
    fetchAllVolunteers(AdminId);
  }, []);

  const filteredKycVolunteer = (volunteerKycList || []).filter((v) => {
    const searchLower = search.toLowerCase();

    return [v.volunteer_code, v.name, v.email, v.phone, v.city, v.area].some(
      (field) => field?.toLowerCase().includes(searchLower),
    );
  });

  const indexOfLast = currentPage * volunteersPerPage;
  const indexOfFirst = indexOfLast - volunteersPerPage;
  const currentVolunteers = filteredVolunteers?.slice(
    indexOfFirst,
    indexOfLast,
  );
  const currentKycVolunteers = filteredKycVolunteer?.slice(
    indexOfFirst,
    indexOfLast,
  );
  const totalPages = Math.ceil(filteredVolunteers?.length / volunteersPerPage);
  const totalKycPages = Math.ceil(
    filteredKycVolunteer?.length / volunteersPerPage,
  );

  const handleChargeChange = (e) => {
    const { name, value } = e.target;

    setChargeForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddVolunteerCharge = async () => {
    if (!chargeForm.volunteerId || !chargeForm.perDayAmount) {
      return;
    }

    try {
      setAddingCharge(true);

      const res = await addVolunteerChargesApi({
        adminId: AdminId || "",
        volunteerId: chargeForm.volunteerId,
        perDayAmount: chargeForm.perDayAmount,
      });

      if (res?.responseCode === "00") {
        setChargeForm({
          volunteerId: "",
          perDayAmount: "",
        });

        await fetchVolunteerCharges("");
      }
    } finally {
      setAddingCharge(false);
    }
  };

  useEffect(() => {
    if (activeTab === "Kyc Details") fetchAllVolunteerKycDetails();
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "Charges") {
      fetchVolunteerCharges("");
    }
  }, [activeTab, fetchVolunteerCharges]);

  useEffect(() => {
    if (editKycVolunteer && editKycModalOpen) {
      setKycFormData({
        volunteer_code:
          editKycVolunteer.volunteerId || editKycVolunteer.volunteer_code || "",
        email: editKycVolunteer.email || "",
        phone: editKycVolunteer.phone || "",
        city: editKycVolunteer.city || "",
        area: editKycVolunteer.area || "",
        profilePicture:
          editKycVolunteer.profilePicture ||
          editKycVolunteer.profilePicture ||
          null,
        aadhaar_no:
          editKycVolunteer.aadharNumber || editKycVolunteer.aadhaar_no || "",
        aadhaar_front:
          editKycVolunteer.aadharFrontPhoto ||
          editKycVolunteer.aadhaar_front ||
          null,
        aadhaar_back:
          editKycVolunteer.aadharBackPhoto ||
          editKycVolunteer.aadhaar_back ||
          null,
        pan_no: editKycVolunteer.panCard || editKycVolunteer.pan_no || "",
        pan_front:
          editKycVolunteer.panCardFrontPhoto ||
          editKycVolunteer.pan_front ||
          null,
        driving_licence:
          editKycVolunteer.drivingLicenseNumber ||
          editKycVolunteer.driving_licence ||
          "",
        driving_licence_img:
          editKycVolunteer.drivingLicenseFrontPhoto ||
          editKycVolunteer.driving_licence_img ||
          null,
        transport_type_id:
          editKycVolunteer.transportTypeID ||
          editKycVolunteer.transport_type_id ||
          "",
        transport_description:
          editKycVolunteer.transportDescription ||
          editKycVolunteer.transport_description ||
          "",
        licence_plate:
          editKycVolunteer.licensePlate || editKycVolunteer.licence_plate || "",
        vehicle_name_plate_img:
          editKycVolunteer.licensePlatePhoto ||
          editKycVolunteer.vehicle_name_plate_img ||
          null,
      });
      setCurrentStep(1);
    }
  }, [editKycVolunteer, editKycModalOpen]);

  const handleEditKyc = (volunteerKycData) => {
    setEditKycVolunteer(volunteerKycData);
    setEditKycModalOpen(true);
  };

  const handleFileChange = (fieldName, file) => {
    setKycFormData((prev) => ({
      ...prev,
      [fieldName]: file,
    }));
  };

  const handleVolunteerSelect = (e) => {
    const selectedVolunteerCode = e.target.value;
    const selectedVolunteer = volunteer.find(
      (v) => v.volunteer_code === selectedVolunteerCode,
    );

    if (selectedVolunteer) {
      setKycFormData((prev) => ({
        ...prev,
        volunteer_code: selectedVolunteerCode,
        email: selectedVolunteer.email || "",
        phone: selectedVolunteer.phone || "",
      }));
    }
  };

  const resetForm = () => {
    setKycFormData({
      volunteer_code: "",
      email: "",
      phone: "",
      aadhaar_no: "",
      pan_no: "",
      city: "",
      area: "",
      profilePicture: null,
      aadhaar_front: null,
      aadhaar_back: null,
      pan_front: null,
    });
  };

  const closeKycModal = () => {
    setEditKycModalOpen(false);
    setEditKycVolunteer(null);
    setCurrentStep(1);
    resetForm();
  };

  const closeModel = () => {
    setOpenKycDialogId(null);
    setSelectedVolunteer(null);
    setVolunteerKycStatus(null);
  };

  const populateEditForm = (volunteer) => {
    setKycFormData({
      volunteer_code: volunteer.volunteer_code || "",
      email: volunteer.email || "",
      phone: volunteer.phone || "",
      aadhaar_no: volunteer.aadhaar_no || "",
      pan_no: volunteer.pan_no || "",
      city: volunteer.city || "",
      area: volunteer.area || "",
      profile_photo: volunteer.profile_photo || null,
      aadhaar_front: volunteer.aadhaar_front || null,
      aadhaar_back: volunteer.aadhaar_back || null,
      pan_front: volunteer.pan_front || null,
    });
    setEditKycModalOpen(true);
    setEditKycVolunteer(volunteer);
  };

  const renderVolunteerTable = () => (
    <div className="overflow-x-auto border rounded-md shadow-sm">
      <table className="min-w-full bg-white">
        <thead>
          <tr className="bg-blue-400 text-left text-sm font-semibold text-white">
            <th className="px-4 py-2 text-center">S/N</th>
            <th className="px-4 py-2 text-center">Volunteer ID</th>
            <th className="px-4 py-2 text-center">User Name</th>
            <th className="px-4 py-2 text-center">Name</th>
            <th className="px-4 py-2 text-center">Email</th>
            <th className="px-4 py-2 text-center">Phone</th>
            <th className="px-4 py-2 text-center">User Type</th>
            <th className="px-4 py-2 text-center">Shop Code</th>
            <th className="px-4 py-2 text-center">Shop Name</th>
            <th className="px-4 py-2 text-center">Shop Address</th>
            <th className="px-4 py-2 text-center">Duty Status</th>
            {/* <th className="px-4 py-2 text-center">Status</th> */}
            <th className="px-4 py-2 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentVolunteers?.map((volunteer, index) => (
            <tr key={volunteer.volunteer_code} className="text-sm border-t">
              <td className="px-4 py-2 text-center">
                {indexOfFirst + index + 1}
              </td>
              <td className="px-4 py-2 text-center">
                {volunteer.volunteer_code}
              </td>
              <td className="px-4 py-2 text-center">{volunteer.username}</td>
              <td className="px-4 py-2 font-medium text-center">
                {`${volunteer.first_name || ""} ${volunteer.last_name || ""}`}
              </td>
              <td className="px-4 py-2 text-center">{volunteer.email}</td>
              <td className="px-4 py-2 text-center">
                {volunteer.phone_number}
              </td>
              <td className="px-4 py-2 text-center">{volunteer.user_type}</td>
              <td className="px-4 py-2 text-center">{volunteer.shop_code}</td>
              <td className="px-4 py-2 text-center">{volunteer.shop_name}</td>
              <td className="px-4 py-2 text-center">
                {volunteer.shop_address}
              </td>

              <td className="px-4 py-2 text-center">
                {(() => {
                  const isOn =
                    String(volunteer.duty_status || "")
                      .toLowerCase()
                      .replace("_", " ")
                      .trim() === "on duty";

                  const disabled = togglingId === volunteer.volunteer_code;
                  // console.log("Duty status:", volunteer.duty_status);
                  // console.log("Volunteer object:", volunteer);

                  return (
                    <label
                      className={`relative inline-flex items-center ${
                        disabled
                          ? "opacity-60 pointer-events-none"
                          : "cursor-pointer"
                      }`}
                    >
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={isOn}
                        onChange={() =>
                          toggleVolunteerDutyStatus(volunteer, isOn)
                        }
                        disabled={disabled}
                        aria-checked={isOn}
                        aria-label="Toggle duty status"
                      />

                      <div
                        className={[
                          "w-10 h-5 rounded-full transition-colors duration-300",
                          "bg-gray-300 peer-checked:bg-green-500",
                          "ring-0 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-green-400",
                        ].join(" ")}
                      />

                      <span
                        className={[
                          "absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white shadow",
                          "transition-transform duration-300",
                          "peer-checked:translate-x-[1.25rem]",
                        ].join(" ")}
                      />
                    </label>
                  );
                })()}
              </td>

              {/* <td className="px-4 py-2 text-center">
                <span
                  className={`px-2 py-1 rounded-full text-xs font-semibold ${volunteer.kycStatus === "active" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}
                >
                  {volunteer.kycStatus
                    ? volunteer.kycStatus.charAt(0).toUpperCase() +
                      volunteer.kycStatus.slice(1)
                    : "N/A"}
                </span>
              </td> */}
              <td className="px-4 py-2">
                <div className="flex gap-2 justify-center items-center">
                  {/* <button
                    className="text-green-600 hover:text-green-800"
                    onClick={() => {
                      setNotificationDriver(volunteer);
                      setNotificationModalOpen(true);
                    }}
                  >
                    <Bell size={14} />
                  </button> */}
                  {/* 
                  <Dialog.Root
                    open={openDialogId === volunteer.volunteer_code}
                    onOpenChange={(open) =>
                      setOpenDialogId(open ? volunteer.volunteer_code : null)
                    }
                  >
                    <Dialog.Trigger asChild>
                      <button className="text-red-600 hover:text-red-800">
                        <Trash size={14} />
                      </button>
                    </Dialog.Trigger>
                    <Dialog.Portal>
                      <Dialog.Overlay className="fixed inset-0 bg-black/40 z-50" />
                      <Dialog.Content className="bg-white rounded-md shadow-lg p-6 w-[90%] max-w-sm fixed top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 z-50">
                        <Dialog.Title className="text-lg font-semibold mb-2">
                          Confirm Deletion
                        </Dialog.Title>
                        <Dialog.Description className="text-sm text-gray-600 mb-4">
                          Are you sure you want to delete volunteer{" "}
                          <strong>{volunteer.fullName}</strong>?
                        </Dialog.Description>
                        <div className="flex justify-end gap-2">
                          <Dialog.Close asChild>
                            <button className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 text-sm">
                              Cancel
                            </button>
                          </Dialog.Close>
                          <button
                            onClick={() =>
                              deleteDriver(volunteer.volunteer_code)
                            }
                            className="px-3 py-1 rounded bg-red-600 hover:bg-red-700 text-white text-sm disabled:opacity-50"
                            disabled={loading}
                          >
                            {loading ? "Deleting..." : "Yes, Delete"}
                          </button>
                        </div>
                      </Dialog.Content>
                    </Dialog.Portal>
                  </Dialog.Root> */}

                  {/* <button
                    className="text-blue-600 hover:text-blue-800"
                    onClick={() => {
                      setEditDriver(volunteer);
                      setEditModalOpen(true);
                    }}
                  >
                    <Pen size={14} />
                  </button> */}
                  {/* Details */}
                  <button
                    className="text-gray-700 hover:text-gray-900"
                    title="Driver Details"
                    onClick={() => {
                      setDetailsVolunteer(volunteer);
                      setDetailsModalOpen(true);
                    }}
                  >
                    <Info size={14} />
                  </button>

                  {/* Assign Shop */}
                  <button
                    className="text-indigo-600 hover:text-indigo-800"
                    title="Assign Shop"
                    onClick={() => {
                      setSelectedVolunteerForShop(volunteer);
                      setAssignShopOpen(true);
                    }}
                  >
                    <Store size={14} />
                  </button>

                  <button
                    className="text-green-600 hover:text-green-800"
                    title="Update Duty"
                    onClick={() => {
                      setSelectedVolunteerForDuty(volunteer);
                      setDutyModalOpen(true);
                    }}
                  >
                    <Clock size={14} />
                  </button>

                  {/* <button
                    className="text-blue-600 hover:text-blue-800"
                    title="Assign Multiple Teams"
                    onClick={() => {
                      setSelectedVolunteerForTeams(volunteer.volunteerId);
                      setAssignTeamDriverObj(volunteer);
                      setAssignTeamsOpen(true);
                    }}
                  >
                    <UserPlus size={14} />
                  </button> */}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderKycTable = () => (
    <div className="overflow-x-auto border rounded-md shadow-sm">
      <table className="min-w-full bg-white">
        <thead>
          <tr className="bg-blue-400 text-left text-sm font-semibold text-white">
            <th className="px-4 py-2 text-center">S/N</th>
            <th className="px-4 py-2 text-center">Volunteer ID</th>
            <th className="px-4 py-2 text-center">Name</th>
            <th className="px-4 py-2 text-center">Email</th>
            <th className="px-4 py-2 text-center">Phone</th>
            <th className="px-4 py-2 text-center">City</th>
            <th className="px-4 py-2 text-center">Area</th>
            <th className="px-4 py-2 text-center">Step</th>
            <th className="px-4 py-2 text-center">Status</th>
            <th className="px-4 py-2 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentKycVolunteers?.map((volunteer, index) => (
            <tr key={volunteer.id} className="text-sm border-t">
              <td className="px-4 py-2 text-center">
                {indexOfFirst + index + 1}
              </td>

              <td className="px-4 py-2 text-center">
                {volunteer.volunteer_code}
              </td>

              <td className="px-4 py-2 text-center">{volunteer.name}</td>

              <td className="px-4 py-2 text-center">{volunteer.email}</td>

              <td className="px-4 py-2 text-center">{volunteer.phone}</td>

              <td className="px-4 py-2 text-center">{volunteer.city}</td>

              <td className="px-4 py-2 text-center">{volunteer.area}</td>

              <td className="px-4 py-2 text-center">
                Step {volunteer.current_step}
              </td>

              <td className="px-4 py-2 text-center">
                <span
                  className={`px-2 py-1 rounded-full text-xs font-semibold ${
                    volunteer.status === "A"
                      ? "bg-green-100 text-green-700"
                      : volunteer.status === "R"
                        ? "bg-red-100 text-red-700"
                        : "bg-yellow-100 text-yellow-700"
                  }`}
                >
                  {volunteer.status === "A"
                    ? "Approved"
                    : volunteer.status === "R"
                      ? "Rejected"
                      : "Pending"}
                </span>
              </td>

              <td className="px-4 py-2">
                <div className="flex items-center justify-center gap-3">
                  <button
                    className="text-gray-500 hover:text-gray-700"
                    onClick={() => {
                      setSelectedVolunteer(volunteer);
                      setOpenKycDialogId(volunteer.volunteer_code);
                    }}
                  >
                    <Eye size={18} />
                  </button>

                  {volunteer.status === "A" && (
                    <button
                      className="text-indigo-600 hover:text-indigo-800"
                      title="Assign Shop"
                      onClick={() => {
                        setSelectedVolunteerForShop(volunteer);
                        setAssignShopOpen(true);
                      }}
                    >
                      <Store size={16} />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderVolunteerChargesTable = () => (
    <div className="space-y-5">
      {/* ADD CHARGE CARD */}
      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div className="border-b border-slate-100 bg-gradient-to-r from-blue-50 via-white to-emerald-50 px-5 py-4">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-blue-600 text-white shadow-sm">
                <WalletCards size={18} />
              </div>

              <div>
                <h2 className="text-base font-semibold text-slate-900">
                  Add Volunteer Daily Charge
                </h2>
                <p className="text-xs text-slate-500">
                  Select a volunteer and define their per-day earning amount.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="p-5">
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-[1.4fr_1fr_auto] lg:items-end">
            {/* Volunteer Select */}
            <div>
              <label className="mb-1.5 flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
                <UserRound size={14} />
                Volunteer
              </label>

              <select
                name="volunteerId"
                value={chargeForm.volunteerId}
                onChange={handleChargeChange}
                className="h-11 w-full rounded-xl border border-slate-200 bg-slate-50 px-3 text-sm font-medium text-slate-700 outline-none transition focus:border-blue-400 focus:bg-white focus:ring-4 focus:ring-blue-50"
              >
                <option value="">Select Volunteer</option>
                {(volunteer || []).map((v) => (
                  <option key={v.volunteer_code} value={v.volunteer_code}>
                    {v.volunteer_code} - {v.first_name} {v.last_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Amount Input */}
            <div>
              <label className="mb-1.5 flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
                <IndianRupee size={14} />
                Per Day Amount
              </label>

              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm font-semibold text-slate-400">
                  ₹
                </span>

                <input
                  type="number"
                  name="perDayAmount"
                  value={chargeForm.perDayAmount}
                  onChange={handleChargeChange}
                  placeholder="Example: 500"
                  className="h-11 w-full rounded-xl border border-slate-200 bg-slate-50 pl-8 pr-3 text-sm font-medium text-slate-700 outline-none transition focus:border-blue-400 focus:bg-white focus:ring-4 focus:ring-blue-50"
                />
              </div>
            </div>

            {/* Submit */}
            <button
              type="button"
              onClick={handleAddVolunteerCharge}
              disabled={
                addingCharge ||
                !chargeForm.volunteerId ||
                !chargeForm.perDayAmount
              }
              className="inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-blue-600 px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {addingCharge ? (
                <>
                  <RefreshCcw size={15} className="animate-spin" />
                  Saving...
                </>
              ) : (
                <>
                  <Save size={15} />
                  Save Charge
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* CHARGES TABLE */}
      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
          <div>
            <h2 className="text-base font-semibold text-slate-900">
              Volunteer Charges
            </h2>
            <p className="text-xs text-slate-500">
              Total records: {volunteerCharges?.length || 0}
            </p>
          </div>

          <button
            type="button"
            onClick={() => fetchVolunteerCharges("")}
            className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-xs font-semibold text-slate-700 transition hover:bg-slate-100"
          >
            <RefreshCcw size={14} />
            Refresh
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead>
              <tr className="bg-slate-50 text-left text-xs font-bold uppercase tracking-wide text-slate-500">
                <th className="px-5 py-3 text-center">S/N</th>
                <th className="px-5 py-3 text-center">Volunteer Code</th>
                <th className="px-5 py-3 text-center">Volunteer Name</th>
                <th className="px-5 py-3 text-center">Per Day Amount</th>
                <th className="px-5 py-3 text-center">Created On</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100">
              {volunteerCharges?.length > 0 ? (
                volunteerCharges.map((item, index) => (
                  <tr
                    key={item.id || index}
                    className="text-sm transition hover:bg-blue-50/40"
                  >
                    <td className="px-5 py-4 text-center text-slate-600">
                      {index + 1}
                    </td>

                    <td className="px-5 py-4 text-center">
                      <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700">
                        {item.volunteer_code || "-"}
                      </span>
                    </td>

                    <td className="px-5 py-4 text-center font-medium text-slate-800">
                      {item.volunteer_name || "-"}
                    </td>

                    <td className="px-5 py-4 text-center">
                      <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-3 py-1 text-sm font-bold text-emerald-700">
                        <IndianRupee size={13} />
                        {Number(item.per_day_amount || 0).toFixed(2)}
                      </span>
                    </td>

                    <td className="px-5 py-4 text-center text-xs text-slate-500">
                      {item.created_on
                        ? new Date(item.created_on).toLocaleString()
                        : "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="5"
                    className="px-5 py-12 text-center text-sm text-slate-500"
                  >
                    No volunteer charges found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  const renderTabNavigation = () => (
    <div className="mb-4 border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        <button
          onClick={() => setActiveTab("list")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === "list"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-gray-600"
          }`}
        >
          Volunteer
        </button>
        <button
          onClick={() => setActiveTab("Kyc Details")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === "Kyc Details"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-gray-600"
          }`}
        >
          Kyc Details
        </button>
        <button
          onClick={() => setActiveTab("Charges")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
            activeTab === "Charges"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-gray-600"
          }`}
        >
          Charges
        </button>

      </nav>
    </div>
  );

  const renderSearchAndFilters = () => (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
      {activeTab !== "Charges" && (
        <div className="flex flex-wrap items-end gap-2">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={
              activeTab === "Kyc Details"
                ? "Search by email or volunteer code..."
                : "Search name or username..."
            }
            className="px-2 py-1 border rounded text-xs shadow-sm w-[220px]"
            autoComplete="off"
          />
        </div>
      )}

      {activeTab === "list" && renderVolunteerActions()}
      {activeTab === "Kyc Details" && renderKycActions()}
    </div>
  );

  const renderVolunteerActions = () => (
    <div className="flex flex-wrap items-end gap-2">
      {/* <select
        className="text-xs border rounded px-2 py-1 shadow-sm w-[130px]"
        value={selectedTeam}
        onChange={(e) => setSelectedTeam(e.target.value)}
      >
        <option value="">All Teams</option>
        {teams?.map((team) => (
          <option key={team.id} value={team.team_name}>
            {team.team_name}
          </option>
        ))}
      </select> */}

      <select
        className="text-xs border rounded px-2 py-1 shadow-sm w-[130px]"
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
      >
        <option value="">All Status</option>
        <option value="active">Active</option>
        <option value="offline">Offline</option>
      </select>

      <button
        className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() =>
          exportAnyJsonToExcel({
            data: volunteer,
            filePrefix: "VolunteersExport",
            sheetName: "VolunteersList",
          })
        }
      >
        <FileDown size={14} />
        <span>Export</span>
      </button>

      <button
        className="flex items-center space-x-2 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => setModalOpen(true)}
      >
        <Plus size={14} />
        <span>Add Volunteer</span>
      </button>

      <button
        onClick={() => fetchAllVolunteers(AdminId)}
        className="flex items-center space-x-1 bg-gray-600 hover:bg-gray-400 text-white px-4 py-0.5 rounded shadow"
        disabled={loading}
      >
        <RefreshCcw size={16} />
        <span>Refresh</span>
      </button>
    </div>
  );

  const renderKycActions = () => (
    <div className="flex flex-wrap items-end gap-2">
      <button
        className="flex items-center space-x-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => {
          fetchAllVolunteers(AdminId || "");
          setEditKycVolunteer(null);
          resetForm();
          setCurrentStep(1);
          setEditKycModalOpen(true);
        }}
      >
        <Plus size={14} />
        <span>Add KYC</span>
      </button>
    </div>
  );

  const renderPagination = () => {
    const totalCount =
      activeTab === "list"
        ? filteredVolunteers?.length || 0
        : filteredKycVolunteer?.length || 0;

    return (
      <TablePagination
        currentPage={currentPage}
        totalCount={totalCount}
        pageSize={volunteersPerPage}
        onPageChange={setCurrentPage}
      />
    );
  };

  const renderModals = () => {
    const isAnyModalOpen =
      modalOpen ||
      editModalOpen ||
      notificationModalOpen ||
      editKycModalOpen ||
      !!selectedVolunteer ||
      detailsModalOpen ||
      teamSelectOpen ||
      assignTeamsOpen ||
      assignShopOpen ||
      dutyModalOpen ||
      primaryTeamOpen;

    if (!isAnyModalOpen) return null;

    return (
      <>
        <AddVolunteerModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          Refresh={fetchAllVolunteers}
          AdminId={AdminId}
        />
        <EditVolunteerModal
          isOpen={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          // volunteer={editVolunteer}
          // teams={teams}
          onDriverUpdated={() => fetchAllVolunteers()}
          // editDriverApi={editDriverApi}
          // updateDriverDutyApi={updateDriverDutyApi}
        />

        <AssignVolunteerModal
          isOpen={assignTeamsOpen}
          onClose={() => setAssignTeamsOpen(false)}
          volunteerId={selectedVolunteerForTeams}
          // teams={teams}
          volunteer={assignTeamDriverObj}
          // fetchDriverMultipleTeams={fetchDriverMultipleTeams}
          // updateDriverActiveTeam={updateDriverActiveTeam}
          // deleteDriverMultipleTeams={deleteDriverMultipleTeams}
          onNext={(volunteerId, teamIds, existingTeams) => {
            setSelectedVolunteerForTeams(volunteerId);
            setTeamDriverId(volunteerId);
            setSelectedTeamIds(teamIds);
            setDriverExistingTeams(existingTeams);
            setAssignTeamsOpen(false);
            setPrimaryTeamOpen(true);
          }}
        />

        <EditVolunteerKycModal
          editKycModalOpen={editKycModalOpen}
          volunteers={volunteer}
          setEditKycModalOpen={setEditKycModalOpen}
          editKycVolunteer={editKycVolunteer}
          setEditKycVolunteer={setEditKycVolunteer}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          kycFormdata={kycFormdata}
          setKycFormData={setKycFormData}
          handleVolunteerSelect={handleVolunteerSelect}
          handleFileChange={handleFileChange}
          handleStepSubmit={submitVolunteerKycStep}
          uploadImageToServer={uploadImageToServer}
          resetForm={resetForm}
          Loading={Loading}
          fetchVolunteerKycDetails={fetchVolunteerKycDetails}
          fetchAllVolunteers={fetchAllVolunteers}
          onSuccess={() => {
            if (activeTab === "Kyc Details") {
              fetchVolunteerKycDetails();
            }
          }}
          activeTab={activeTab}
          AdminId={AdminId}
        />

        <ViewVolunteerKycDetails
          selectedVolunteer={selectedVolunteer}
          setSelectedVolunteer={setSelectedVolunteer}
          previewImage={previewImage}
          setPreviewImage={setPreviewImage}
          openKycDialogId={openKycDialogId}
          setOpenKycDialogId={setOpenKycDialogId}
          AdminId={AdminId}
        />

        <AssignVolunteerShopModal
          isOpen={assignShopOpen}
          onClose={() => setAssignShopOpen(false)}
          volunteer={selectedVolunteerForShop}
          onSuccess={() => {
            fetchAllVolunteers(AdminId || "");
            setAssignShopOpen(false);
          }}
        />
        <VolunteerDetailsModal
          open={detailsModalOpen}
          onOpenChange={setDetailsModalOpen}
          volunteer={detailsVolunteer}
        />

        <VolunteerDutyModal
          isOpen={dutyModalOpen}
          onClose={() => setDutyModalOpen(false)}
          volunteer={selectedVolunteerForDuty}
          updateVolunteerDutyTypeApi={updateVolunteerDutyTypeApi}
          onUpdated={() => fetchAllVolunteers(AdminId || "")}
        />
      </>
    );
  };

  return (
    <div className="p-4">
      <Toaster position="top-right" />

      <div className="flex justify-between items-center">
        <h1 className="text-xl font-semibold">Volunteer</h1>
      </div>

      {renderTabNavigation()}
      {renderSearchAndFilters()}

      {loading || volunteerChargesLoading ? (
        <LoadingScreen />
      ) : (
        <>
          {activeTab === "list" && renderVolunteerTable()}
          {activeTab === "Kyc Details" && renderKycTable()}
          {activeTab === "Charges" && renderVolunteerChargesTable()}
        </>
      )}

      {renderModals()}
    </div>
  );
}
